import { NotificationClientService, NotificationType } from '../../../../../../services/basics/notification-client.service';
import { autoinject } from "aurelia-dependency-injection";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { CustomerSubscriptionModel } from '../../../../../../models/customers/customer-subscription.models';
import { RightStoreService } from '../../../../../../services/rightstore/rightstore.service';
import { ValidationController, ValidationControllerFactory, ValidationRules } from 'aurelia-validation';
import { CustomValidationRenderer } from '../../../../../../client-validation-system/custom-validation-renderer';
import { observable } from 'aurelia-binding';
import { RightShipDialogServiceConstants } from '../../../../../../constants/basics/rightship-dialog.constants';
import { RightStoreProductTypeEnum } from '../../../../../../models/rightstore/rightstore.models';

@autoinject
export class EditCustomerAPISubscriptionDialog {

    private validator: ValidationController;
    public ApiSubscriptions: CustomerSubscriptionModel[];
    public selectedProduct: CustomerSubscriptionModel;
    public isLoading: boolean;
    public customerId: number;
    public afterSave: () => void;
    public isRightshipUser: boolean;

    @observable
    public selectedProductCode: string;

    constructor(private dialogClientService: DialogClientService,
        private notificationClientService: NotificationClientService,
        private rightStoreService: RightStoreService,
        validationControllerFactory: ValidationControllerFactory) {
            this.validator = validationControllerFactory.createForCurrentScope();
            this.validator.addRenderer(new CustomValidationRenderer());
    }

    activate(model: { customerId: number, afterSave: () => void }) {
        this.customerId = model.customerId;

        //Get customer unscubscribe subscription
        this.rightStoreService.getCustomerUnsubscribedSubscriptions(model.customerId).then(response => {
            this.ApiSubscriptions = response.customerSubscriptions;
            this.validator.addObject(this, this.getRules());
            this.afterSave = model.afterSave;
        });
    }

    //Get rules for validations
    getRules() {
        const rules = ValidationRules
            .ensure("selectedProductCode")
            .required()
            .withMessage("Please select a product")
        return rules.rules;
    }

    //Selected product code changed
    selectedProductCodeChanged() {
        const product = this.ApiSubscriptions.find(x => x.productCode == this.selectedProductCode);
        if(product) this.selectedProduct = product;
    }

    //Add subscription
    async addSubscription() {
        try {
            const isValid = await this.validator.validate();
            if(isValid.valid) {
                const dialogConstant = this.selectedProduct.productType === RightStoreProductTypeEnum.Subscription ? RightShipDialogServiceConstants.URLs.EditCustomerSubscriptionDialog : RightShipDialogServiceConstants.URLs.EditCustomerAPISubscriptionDialog;
                this.dialogClientService.show(dialogConstant,
                    {
                        productCode: this.selectedProduct.productCode,
                        productName: this.selectedProduct.productName,
                        productId: this.selectedProduct.productId,
                        customerId: this.customerId,
                        afterSave: () => {
                            this.afterSave();
                            this.cancel();
                        }
                    },
                    false, false, false, 'right');
            }
        } catch (error) {
            this.notificationClientService.show("An error occurred while adding the subscription", "", NotificationType.Error);
        }
    }

    //Cancel
    cancel() {
        this.dialogClientService.hide();
    }
}